<template>
  <div style="" class="father">
    <div style="display:flex;">
      <div class="right">
        <div class="title">
          开卡
          <!-- <b style="color: red;" >必填</b> -->选项
        </div>
        <el-scrollbar wrapStyle="overflow-x:hidden;" style="width: 100%;height: 490px;background-color: #fff;">
          <div class="father">
            <el-form label-width="300px" style="background-color: #fff; padding:0 20px 0 20px;width: 100%"
              ref="dataFormRef" label-position="top">
              <el-form-item label="开卡必填项：">
                <el-select v-model="required_form.common_field_id_list" style="width: 500px;" multiple
                  placeholder="选择开卡必填项">
                  <el-option v-for="item in required_column_list" :disabled="item.disabled" :key="item.value"
                    :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开卡选填项：">
                <el-select v-model="optional_form.common_field_id_list" style="width: 500px;" multiple
                  placeholder="选择开卡选填项">
                  <el-option v-for="item in optional_column_list" :disabled="item.disabled" :key="item.value"
                    :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-scrollbar>
      </div>
      <div class="right" v-if="false">
        <div class="title">
          开卡 <b style="color: rgb(36, 198, 0);">选填</b> 项
        </div>
        <el-scrollbar wrapStyle="overflow-x:hidden;" style="width: 100%;height: 490px;background-color: #fff;">
          <div class="father">
            <el-form label-width="300px" style="background-color: #fff; padding:0 20px 0 20px;width: 100%"
              ref="dataFormRef" label-position="top">
              <el-form-item label=""> </el-form-item>
            </el-form>
          </div>
        </el-scrollbar>
      </div>
    </div>

    <div class="wty-footer">
      <el-button type="primary" @click="saveCardCantent"> 保存设置 </el-button>
    </div>
  </div>
</template>
<script>
import { wxServiceCardSetActiveFormData } from "@/api/wxService.js";
export default {
  name: "cardCantent",
  data() {
    return {
      required_column_list: [
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_MOBILE",
          label: "手机号"
        },
        { disabled: false, value: "USER_FORM_INFO_FLAG_SEX", label: "性别" },
        { disabled: false, value: "USER_FORM_INFO_FLAG_NAME", label: "姓名" },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_BIRTHDAY",
          label: "生日"
        },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_IDCARD",
          label: "身份证"
        },
        { disabled: false, value: "USER_FORM_INFO_FLAG_EMAIL", label: "邮箱" },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_LOCATION",
          label: "详细地址"
        },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_EDUCATION_BACKGRO",
          label: "教育背景"
        },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_INDUSTRY",
          label: "行业"
        },
        { disabled: false, value: "USER_FORM_INFO_FLAG_INCOME", label: "收入" },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_HABIT",
          label: "兴趣爱好"
        }
      ],
      optional_column_list: [
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_MOBILE",
          label: "手机号"
        },
        { disabled: false, value: "USER_FORM_INFO_FLAG_SEX", label: "性别" },
        { disabled: false, value: "USER_FORM_INFO_FLAG_NAME", label: "姓名" },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_BIRTHDAY",
          label: "生日"
        },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_IDCARD",
          label: "身份证"
        },
        { disabled: false, value: "USER_FORM_INFO_FLAG_EMAIL", label: "邮箱" },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_LOCATION",
          label: "详细地址"
        },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_EDUCATION_BACKGRO",
          label: "教育背景"
        },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_INDUSTRY",
          label: "行业"
        },
        { disabled: false, value: "USER_FORM_INFO_FLAG_INCOME", label: "收入" },
        {
          disabled: false,
          value: "USER_FORM_INFO_FLAG_HABIT",
          label: "兴趣爱好"
        }
      ],

      required_form: {
        can_modify: false,
        common_field_id_list: ["USER_FORM_INFO_FLAG_MOBILE"]
      },
      optional_form: {
        can_modify: false,
        common_field_id_list: []
      }
    };
  },
  watch: {
    optional_lt: {
      handler(newopt, oldopt) {
        this.setColumnDisabled(this.required_column_list, newopt);
      },
      deep: true,
      immediate: true
    },
    required_lt: {
      handler(newreq, oldreq) {
        if (newreq.indexOf("USER_FORM_INFO_FLAG_MOBILE") < 0) {
          newreq.push("USER_FORM_INFO_FLAG_MOBILE");
          this.warnMessage("手机号为必传项");
        }
        this.setColumnDisabled(this.optional_column_list, newreq);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    optional_lt() {
      return this.optional_form.common_field_id_list;
    },
    required_lt() {
      return this.required_form.common_field_id_list;
    }
  },
  // components: { uploadImg },
  async mounted() {
  },
  methods: {
    /* phoneDontChange(e){
      console.log(e);
      if(e=="")
    }, */
    async saveCardCantent() {
      const res = await wxServiceCardSetActiveFormData({
        required_form: this.required_form,
        optional_form: this.optional_form
      });
      if (
        res.data.return_code === "SUCCESS" &&
        res.data.result_code === "SUCCESS" && res.data.resp_data
      ) {
        const resp = JSON.parse(res.data.resp_data);
        //TODO: 修改接口返回现在失败
        console.log("修改接口返回", res);
        if (
          res.data &&
          resp &&
          resp.errcode === 0 &&
          resp.errmsg === "ok"
        ) {
          this.successMessage("开卡填写内容修改成功！");
        } else if (res.data && resp && resp.errcode !== 0 && resp.errmsg) {
          this.warnMessage(resp.errmsg);
        }
      }
    },
    /**
     *
     * @param {*} column_list required_column_list 或者是 optional_column_list
     * @param {*} list  一个数组
     */
    setColumnDisabled(column_list, list) {
      for (let i = 0; i < column_list.length; i++) {
        column_list[i].disabled = false;
      }
      for (let i = 0; i < column_list.length; i++) {
        if (list.indexOf(column_list[i].value) > -1) {
          column_list[i].disabled = true;
        }
      }
    }
  }
};
</script>
<style scoped lang="less">
.title {
  border-bottom: 2px solid rgb(0, 89, 184);
  color: rgb(0, 89, 184);
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
}

.el-breadcrumb {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  padding-left: 20px;
  padding-top: 5px;
  margin-bottom: 0;
  font-size: 16px;
  z-index: 99;
}

.father {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  display: flex;
  justify-content: top;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
}

.fa-morf {
  margin-top: 20px;
}

.right {
  width: 50%;
  min-width: 600px;
  float: left;
  padding-right: 10px;
}

.el-input {
  width: 400px;
}

.wty-footer {
  height: 50px;

  .el-button {
    width: 200px;
  }
}
</style>
